import { ObjectKeys } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-settings.type';

export function cleanHighchartsData(data?: ObjectKeys[]): ObjectKeys[] {
  if (!data) {
    return [];
  }

  return data.map((item) => {
    let cleanedValue = cleanHighchartsValue(item.value);

    return {
      date: item.date,
      value: cleanedValue,
    };
  });
}

export function cleanHighchartsValue(value: any) {
  let cleanedValue: number | null;

  if (typeof value === 'string') {
    const lowerCaseValue = String(value).toLowerCase();

    if (lowerCaseValue === 'infinity') {
      cleanedValue = Infinity;
    } else if (lowerCaseValue === 'nan') {
      cleanedValue = NaN;
    } else {
      const parsed = parseFloat(value);
      cleanedValue = isNaN(parsed) ? NaN : parsed;
    }
  } else if (typeof value === 'number') {
    cleanedValue = isNaN(value) ? NaN : value;
  } else {
    cleanedValue = NaN;
  }
  return cleanedValue;
}
